// Destination-consistent catalog.
// Every hotel is bound to its real country + city + image so that
// image / hotel name / country / city / airline never mismatch.

// Curated resort/beach/lobby imagery per destination category — no city
// landmarks that could visually contradict the country name.
const IMG = {
  turkey: [
    'https://images.unsplash.com/photo-1583417319070-4a69db38a482?auto=format&fit=crop&w=900&q=75', // Antalya resort pool
    'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=900&q=75', // resort pool
    'https://images.unsplash.com/photo-1519449556851-5720b33024e7?auto=format&fit=crop&w=900&q=75', // mediterranean coast
    'https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=900&q=75', // hotel lobby
  ],
  egypt: [
    'https://images.unsplash.com/photo-1615460549969-36fa19521a4f?auto=format&fit=crop&w=900&q=75', // red-sea style resort
    'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=900&q=75', // beach
    'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=900&q=75', // pool
    'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&w=900&q=75', // lobby
  ],
  uae: [
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=900&q=75', // dubai skyline resort
    'https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=900&q=75', // dubai
    'https://images.unsplash.com/photo-1546412414-e1885259563a?auto=format&fit=crop&w=900&q=75', // dubai palm
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=900&q=75', // luxury hotel
  ],
  thailand: [
    'https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=900&q=75', // palm beach
    'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?auto=format&fit=crop&w=900&q=75', // beach resort
    'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=900&q=75', // tropical beach
    'https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=900&q=75', // room
  ],
  maldives: [
    'https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=900&q=75', // overwater villas
    'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?auto=format&fit=crop&w=900&q=75', // maldives
    'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=900&q=75', // overwater
    'https://images.unsplash.com/photo-1500375592092-40eb2168fd21?auto=format&fit=crop&w=900&q=75', // turquoise sea
  ],
  vietnam: [
    'https://images.unsplash.com/photo-1528181304800-259b08848526?auto=format&fit=crop&w=900&q=75', // ha long
    'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=900&q=75', // beach vietnam
    'https://images.unsplash.com/photo-1509233725247-49e657c54213?auto=format&fit=crop&w=900&q=75', // tropical
    'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?auto=format&fit=crop&w=900&q=75', // resort
  ],
  srilanka: [
    'https://images.unsplash.com/photo-1546707012-c44b0055f18b?auto=format&fit=crop&w=900&q=75', // sri lanka beach
    'https://images.unsplash.com/photo-1591825729269-caeb344f6df2?auto=format&fit=crop&w=900&q=75', // tropical
    'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=900&q=75', // mountains sri lanka
    'https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=900&q=75', // palm
  ],
  cyprus: [
    'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=900&q=75', // beach
    'https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?auto=format&fit=crop&w=900&q=75', // mediterranean village
    'https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&w=900&q=75', // greek/mediterranean
    'https://images.unsplash.com/photo-1519449556851-5720b33024e7?auto=format&fit=crop&w=900&q=75', // coast
  ],
  sochi: [
    'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=900&q=75', // mountains
    'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=900&q=75', // mountains
    'https://images.unsplash.com/photo-1587874522487-3d2d0dbc9ee5?auto=format&fit=crop&w=900&q=75', // hotel room
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=75', // hotel
  ],
  abkhazia: [
    'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=900&q=75', // mountains
    'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?auto=format&fit=crop&w=900&q=75', // sea/resort
    'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=900&q=75', // beach
    'https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=900&q=75', // lobby
  ],
};

const pickImage = (pool, seed) => pool[seed % pool.length];

// Realistic hotels tied to their real city + country.
const CATALOG = {
  'Турция': {
    airlines: ['Turkish Airlines', 'Pegasus', 'AZUR air', 'Southwind Airlines'],
    basePrice: 55000,
    imgPool: IMG.turkey,
    hotels: [
      { name: 'Rixos Premium Belek',      city: 'Белек',   stars: 5 },
      { name: 'Delphin Imperial',         city: 'Лара',    stars: 5 },
      { name: 'Titanic Deluxe Lara',      city: 'Лара',    stars: 5 },
      { name: 'Royal Seginus',            city: 'Лара',    stars: 5 },
      { name: 'Crystal Waterworld Resort',city: 'Белек',   stars: 5 },
      { name: 'IC Hotels Green Palace',   city: 'Анталия', stars: 5 },
      { name: 'Voyage Belek Golf & Spa',  city: 'Белек',   stars: 5 },
      { name: 'Alva Donna World Palace',  city: 'Кемер',   stars: 5 },
      { name: 'Concorde De Luxe Resort',  city: 'Лара',    stars: 5 },
      { name: 'Nashira Resort Hotel',     city: 'Сиде',    stars: 4 },
    ],
  },
  'Египет': {
    airlines: ['Egypt Air', 'AZUR air', 'Red Wings', 'Nordwind Airlines'],
    basePrice: 62000,
    imgPool: IMG.egypt,
    hotels: [
      { name: 'Rixos Sharm El Sheikh',            city: 'Шарм-эль-Шейх', stars: 5 },
      { name: 'Steigenberger Aldau Beach',        city: 'Хургада',       stars: 5 },
      { name: 'Baron Palace Sahl Hasheesh',       city: 'Хургада',       stars: 5 },
      { name: 'Albatros Palace Resort',           city: 'Хургада',       stars: 5 },
      { name: 'Sunrise Arabian Beach',            city: 'Шарм-эль-Шейх', stars: 5 },
      { name: 'Cleopatra Luxury Resort',          city: 'Макади-Бей',    stars: 5 },
      { name: 'Jaz Aquamarine Resort',            city: 'Хургада',       stars: 5 },
      { name: 'Sentido Reef Oasis Senses',        city: 'Шарм-эль-Шейх', stars: 5 },
      { name: 'The Grand Hotel Hurghada',         city: 'Хургада',       stars: 4 },
      { name: 'Marina Lodge at Port Ghalib',      city: 'Марса-Алам',    stars: 4 },
    ],
  },
  'ОАЭ': {
    airlines: ['Emirates', 'flydubai', 'Air Arabia', 'Etihad Airways'],
    basePrice: 89000,
    imgPool: IMG.uae,
    hotels: [
      { name: 'Atlantis The Palm',                city: 'Дубай',         stars: 5 },
      { name: 'JA The Resort',                    city: 'Дубай',         stars: 5 },
      { name: 'Rixos The Palm Dubai',             city: 'Дубай',         stars: 5 },
      { name: 'Jumeirah Beach Hotel',             city: 'Дубай',         stars: 5 },
      { name: 'Grand Hyatt Dubai',                city: 'Дубай',         stars: 5 },
      { name: 'Fairmont Bab Al Bahr',             city: 'Абу-Даби',      stars: 5 },
      { name: 'Rixos Bab Al Bahr',                city: 'Рас-эль-Хайма', stars: 5 },
      { name: 'Waldorf Astoria Ras Al Khaimah',   city: 'Рас-эль-Хайма', stars: 5 },
      { name: 'Fairmont Ajman',                   city: 'Аджман',        stars: 5 },
      { name: 'Sheraton Sharjah Beach Resort',    city: 'Шарджа',        stars: 5 },
    ],
  },
  'Таиланд': {
    airlines: ['Thai Airways', 'Emirates', 'Qatar Airways'],
    basePrice: 128000,
    imgPool: IMG.thailand,
    hotels: [
      { name: 'Katathani Phuket Beach Resort',    city: 'Пхукет',  stars: 5 },
      { name: 'Amari Phuket',                     city: 'Пхукет',  stars: 4 },
      { name: 'Centara Grand Beach Resort',       city: 'Пхукет',  stars: 5 },
      { name: 'Diamond Cliff Resort & Spa',       city: 'Пхукет',  stars: 5 },
      { name: 'Novotel Phuket Kata Avista',       city: 'Пхукет',  stars: 4 },
      { name: 'Centara Grand Mirage Pattaya',     city: 'Паттайя', stars: 5 },
      { name: 'Hard Rock Hotel Pattaya',          city: 'Паттайя', stars: 4 },
      { name: 'Sofitel Krabi Phokeethra',         city: 'Краби',   stars: 5 },
      { name: 'Anantara Bophut Koh Samui',        city: 'Самуи',   stars: 5 },
      { name: 'Melati Beach Resort',              city: 'Самуи',   stars: 5 },
    ],
  },
  'Мальдивы': {
    airlines: ['Emirates', 'Qatar Airways', 'Turkish Airlines'],
    basePrice: 245000,
    imgPool: IMG.maldives,
    hotels: [
      { name: 'Sun Siyam Iru Fushi',              city: 'Атолл Нуну',   stars: 5 },
      { name: 'Kandima Maldives',                 city: 'Атолл Даалу',  stars: 5 },
      { name: 'Cinnamon Hakuraa Huraa',           city: 'Атолл Мииму',  stars: 4 },
      { name: 'Dhigufaru Island Resort',          city: 'Атолл Баа',    stars: 5 },
      { name: 'Villa Nautica',                    city: 'Атолл Ари',    stars: 5 },
      { name: 'Angsana Velavaru',                 city: 'Атолл Даалу',  stars: 5 },
      { name: 'Kuredu Island Resort',             city: 'Атолл Лавияни', stars: 4 },
      { name: 'Meeru Island Resort',              city: 'Атолл Северный Мале', stars: 4 },
    ],
  },
  'Вьетнам': {
    airlines: ['Vietnam Airlines', 'Aeroflot', 'Qatar Airways'],
    basePrice: 118000,
    imgPool: IMG.vietnam,
    hotels: [
      { name: 'Vinpearl Discovery Nha Trang',     city: 'Нячанг',   stars: 5 },
      { name: 'Sheraton Nha Trang Hotel & Spa',   city: 'Нячанг',   stars: 5 },
      { name: 'Radisson Blu Phu Quoc',            city: 'Фукуок',   stars: 5 },
      { name: 'Vinpearl Resort & Spa Phu Quoc',   city: 'Фукуок',   stars: 5 },
      { name: 'InterContinental Danang',          city: 'Дананг',   stars: 5 },
      { name: 'Furama Resort Danang',             city: 'Дананг',   stars: 5 },
      { name: 'Anantara Mui Ne Resort',           city: 'Муйне',    stars: 5 },
      { name: 'The Cliff Resort & Residences',    city: 'Муйне',    stars: 4 },
    ],
  },
  'Шри-Ланка': {
    airlines: ['SriLankan Airlines', 'Emirates', 'Qatar Airways'],
    basePrice: 132000,
    imgPool: IMG.srilanka,
    hotels: [
      { name: 'Cinnamon Bey Beruwala',            city: 'Бентота',    stars: 5 },
      { name: 'Riu Sri Lanka',                    city: 'Ахунгалла',  stars: 5 },
      { name: 'Centara Ceysands Resort',          city: 'Бентота',    stars: 5 },
      { name: 'Heritance Ahungalla',              city: 'Ахунгалла',  stars: 5 },
      { name: 'Anantara Peace Haven Tangalle',    city: 'Тангалле',   stars: 5 },
      { name: 'Jetwing Beach Hotel',              city: 'Негомбо',    stars: 4 },
    ],
  },
  'Кипр': {
    airlines: ['Aegean Airlines', 'Turkish Airlines', 'Cyprus Airways'],
    basePrice: 72000,
    imgPool: IMG.cyprus,
    hotels: [
      { name: 'Grecian Bay Hotel',                city: 'Айя-Напа', stars: 5 },
      { name: 'Adams Beach Hotel',                city: 'Айя-Напа', stars: 5 },
      { name: 'Elias Beach Hotel',                city: 'Лимасол',  stars: 4 },
      { name: 'Athena Beach Hotel',               city: 'Пафос',    stars: 4 },
      { name: 'Amathus Beach Hotel Limassol',     city: 'Лимасол',  stars: 5 },
      { name: 'Constantinou Bros Asimina Suites', city: 'Пафос',    stars: 5 },
      { name: 'Amavi Hotel',                      city: 'Пафос',    stars: 5 },
      { name: 'Palm Beach Hotel & Bungalows',     city: 'Ларнака',  stars: 4 },
    ],
  },
  'Сочи': {
    airlines: ['Аэрофлот', 'Победа', 'S7', 'Red Wings'],
    basePrice: 38000,
    imgPool: IMG.sochi,
    hotels: [
      { name: 'Rixos Krasnaya Polyana',           city: 'Красная Поляна', stars: 5 },
      { name: 'Radisson Collection Paradise',     city: 'Адлер',          stars: 5 },
      { name: 'Богатырь',                          city: 'Адлер',          stars: 4 },
      { name: 'Sochi Marriott Krasnaya Polyana',  city: 'Красная Поляна', stars: 5 },
      { name: 'Poляна 1389',                       city: 'Красная Поляна', stars: 4 },
      { name: 'Mercure Sochi Centre',             city: 'Сочи',           stars: 4 },
      { name: 'Swissôtel Resort Сочи Камелия',    city: 'Сочи',           stars: 5 },
      { name: 'Роза Спрингс',                     city: 'Красная Поляна', stars: 4 },
    ],
  },
  'Абхазия': {
    airlines: ['Аэрофлот', 'Победа', 'S7'],
    basePrice: 29000,
    imgPool: IMG.abkhazia,
    hotels: [
      { name: 'Grand Sport Otel',                 city: 'Гагра',      stars: 4 },
      { name: 'Wardan Resort',                    city: 'Пицунда',    stars: 4 },
      { name: 'Amza Park Hotel',                  city: 'Пицунда',    stars: 4 },
      { name: 'Sunny Beach Resort',               city: 'Гагра',      stars: 4 },
      { name: 'Апра Резорт',                       city: 'Новый Афон', stars: 3 },
      { name: 'Iveria Beach',                     city: 'Сухум',      stars: 3 },
    ],
  },
};

const FOOD_TYPES = ['Ultra All Inclusive', 'All Inclusive', 'Полупансион', 'Завтраки', 'Только завтрак'];
const ROOM_TYPES = ['Standard Room', 'Deluxe Sea View', 'Superior Land View', 'Family Room', 'Junior Suite', 'Bungalow Beach'];

// deterministic-ish RNG
let _seed = Date.now() % 1000000;
const rnd = () => {
  _seed = (_seed * 9301 + 49297) % 233280;
  return _seed / 233280;
};
const pick = (arr) => arr[Math.floor(rnd() * arr.length)];
const range = (a, b) => Math.floor(rnd() * (b - a + 1)) + a;

const formatPrice = (n) => `${Math.round(n).toLocaleString('ru-RU')} ₽`;
const formatDate = (d) => d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'long' });

const buildTour = (countryName, filters, i) => {
  const cat = CATALOG[countryName];

  // pick a hotel ENTRY — image, city, base stars all come from this entry
  // so image / hotel / city / country are guaranteed to match
  const hotelEntry = pick(cat.hotels);
  const stars = filters.category
    ? Math.min(5, Math.max(3, parseInt(filters.category, 10)))
    : hotelEntry.stars;

  const nightsBase = parseInt(filters.nights, 10) || pick([7, 10, 12, 14]);
  const nights = filters.tab === 'hot' ? Math.max(5, nightsBase - range(0, 2)) : nightsBase;

  const starMultiplier = 0.55 + stars * 0.18;
  const nightMultiplier = 0.65 + nights * 0.05;

  const foodOptions = stars >= 4
    ? ['Ultra All Inclusive', 'All Inclusive', 'Полупансион']
    : ['All Inclusive', 'Полупансион', 'Завтраки'];
  const food = filters.food || pick(foodOptions);
  const foodMult = {
    'Ultra All Inclusive': 1.25,
    'All Inclusive': 1.1,
    'Полупансион': 0.95,
    'Завтраки': 0.85,
    'Только завтрак': 0.8,
  }[food] || 1;

  const base = cat.basePrice * starMultiplier * nightMultiplier * foodMult;
  const variation = 0.85 + rnd() * 0.35;
  const current = Math.round((base * variation) / 1000) * 1000 + 990;

  const discountPct = filters.tab === 'hot' ? range(22, 45) : range(8, 27);
  const oldPrice = Math.round((current / (1 - discountPct / 100)) / 1000) * 1000 + 990;

  const today = new Date();
  const daysFromNow = filters.tab === 'hot' ? range(2, 12) : range(6, 60);
  const depDate = new Date(today.getTime() + daysFromNow * 86400000);

  const ratings = stars >= 5 ? [8.9, 9.1, 9.3, 9.5, 9.7]
                : stars >= 4 ? [8.2, 8.4, 8.6, 8.8, 9.0]
                             : [7.4, 7.6, 7.8, 8.0];
  const rating = pick(ratings);

  const image = pickImage(cat.imgPool, i + Math.floor(rnd() * 100));

  return {
    id: `${countryName}-${i}-${Math.floor(rnd() * 1e6)}`,
    hotel: hotelEntry.name,
    country: countryName,
    city: hotelEntry.city,
    stars,
    rating,
    food,
    date: formatDate(depDate),
    nights,
    airline: pick(cat.airlines),
    room: pick(ROOM_TYPES),
    price: formatPrice(current),
    old_price: formatPrice(oldPrice),
    discount: `-${discountPct}%`,
    image,
  };
};

export const ALL_COUNTRIES = Object.keys(CATALOG);
export const ALL_FOOD = FOOD_TYPES;

/**
 * Case-insensitive country lookup so that free-text destination like "турция"
 * or "Turkey" still routes to the correct catalog entry.
 */
const resolveCountry = (dest) => {
  if (!dest) return null;
  const norm = dest.trim().toLowerCase();
  const alias = {
    'turkey': 'Турция',
    'egypt': 'Египет',
    'uae': 'ОАЭ',
    'united arab emirates': 'ОАЭ',
    'thailand': 'Таиланд',
    'maldives': 'Мальдивы',
    'vietnam': 'Вьетнам',
    'sri lanka': 'Шри-Ланка',
    'cyprus': 'Кипр',
    'sochi': 'Сочи',
    'abkhazia': 'Абхазия',
  };
  if (alias[norm]) return alias[norm];
  const hit = ALL_COUNTRIES.find((c) => c.toLowerCase() === norm);
  return hit || null;
};

/**
 * @param {Object} filters
 * @returns {Array}
 */
export const generateTours = (filters = {}) => {
  _seed = (Date.now() ^ Math.floor(Math.random() * 1e6)) % 1000000;
  const total = 8 + Math.floor(Math.random() * 6); // 8..13

  const resolved = resolveCountry(filters.destination);
  const countries = resolved ? [resolved] : ALL_COUNTRIES;

  const tours = [];
  for (let i = 0; i < total; i++) {
    const country = countries[i % countries.length];
    tours.push(buildTour(country, filters, i));
  }
  return tours;
};
